import Moment from 'moment';

$(function(){

    $('.form-ajax-attr').submit(function(e){
      e.preventDefault();

      var id = $(this).attr('id');
      var formObject = $('#'+id);
      var data = $(this).serialize()+'&url='+window.location.href;
      var url = $(this).attr("action");
      var button_txt = $("#btn-"+id).html();
      var widgetId = '';

      $("#btn-"+id).html('loading...');

      $("#response-"+id).html('');
      formObject.find('input, select, textarea').removeClass('error-field');

      var form = $(this);
      var formdata = false;
      if (window.FormData){
          formdata = new FormData(form[0]);
      }

      $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: "POST",
        dataType: "json",
        url: url,
        data: formdata,
        processData: false,
        contentType: false,
        cache: false,

        success: function(e){

            alert(e);

            // we apply red border to fields now
            if(e.invalidFields){
              var _invalidFields = JSON.parse(e.invalidFields);
              for (var i = 0; i < _invalidFields.length; i++) {
                var _field = _invalidFields[i];
                formObject.find('[name="'+_field+'"]').addClass('error-field');
              }
            }

            if(e.flag==3){
                /*
                //RECAPTCHA ALERT
                 var gObject = $("#"+id).find(".g-recaptcha-pw");
                 var grId = gObject.attr('id');
                 var ajaxsitekey = gObject.data('sitekeypw');
                 var ajaxcallback = gObject.data('callbackpw');
                 var ajaxcounter = gObject.attr('data-counterpw');

                 if ( ajaxcounter == '' ){
                     widgetId = grecaptcha.render(grId, {
                      'sitekey' : ajaxsitekey,
                      'callback' : ajaxcallback,
                      'size' : "invisible"
                      });

                     gObject.attr('data-counterpw',widgetId);
                     grecaptcha.reset(widgetId);
                     grecaptcha.execute(widgetId);
                 }else{
                     grecaptcha.reset(ajaxcounter);
                     grecaptcha.execute(ajaxcounter);
                 }
                 */
             }else{
                 if(e.flag){
                   $("#response-"+id).html(e.alert);
                   if(e.flag==1){
                       $("#"+id).find("input[type=email],input[type=text],textarea").val("");
                       $("#"+id).find("input[name='g-recaptcha-response']").val("");
                   }
                 }
                 if(e.hasOwnProperty('msg')){
                   $("#response-"+id).html(e.msg);
                 }
             }

            if(e.hasOwnProperty('alert')){
                $("#response-"+id).html(e.alert);
            }

            if(e.hasOwnProperty('redirect')){
                window.location.replace( e.redirect );
            }

          $("#btn-"+id).html(button_txt);
        },
        complete: function(e){
          $("#btn-"+id).html(button_txt);

        },
        fail: function(e){
          //console.log(e);
        }
      });

      return false;
    });

    /*--------------------------------------------------------
    * MEMBER Register AJAX FORM
    ------------------------------------------------------
    $('.ajax-form-register').submit(function(e){

        var id = $(this).attr('id');
        var action = $(this).attr('action');
        var data = $(this).serialize();
        var button_txt = $("#btn-"+id).html();
        var widgetId = '';

        $("#btn-"+id).html('loading...');
        $("#response-"+id).html('');

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: "json",
            type : "POST",
            url : action,
            data : data,
            success: function(e) {

                $("#response-"+id).html(e.alert);

                if(e.flag==3){ //RECAPTCHA ALERT
                     var gObject = $("#"+id).find(".g-recaptcha-pw");
                     var grId = gObject.attr('id');
                     var ajaxsitekey = gObject.data('sitekeypw');
                     var ajaxcallback = gObject.data('callbackpw');
                     var ajaxcounter = gObject.attr('data-counterpw');

                     if ( ajaxcounter == '' ){
                         widgetId = grecaptcha.render(grId, {
                          'sitekey' : ajaxsitekey,
                          'callback' : ajaxcallback,
                          'size' : "invisible"
                          });

                         gObject.attr('data-counterpw',widgetId);
                         grecaptcha.reset(widgetId);
                         grecaptcha.execute(widgetId);
                     }else{
                         grecaptcha.reset(ajaxcounter);
                         grecaptcha.execute(ajaxcounter);
                     }

                 }

                 if(e.flag=='1'){
                     // when Success...
                     $("#"+id).find("input[type=email],input[type=text],textarea,select").val("");
                     if (typeof e.redirect !== "undefined") {
                         window.location.replace(e.redirect);
                     }
                 }
                 $("#btn-"+id).html(button_txt);

            }
        });

        return false;
     });
     --*/

});

$( document ).ready(function()
{
    $('.date-selection').click(function()
    {
        var chosen_date = $(this).data('date');

        $( ".date-selection" ).each(function()
        {
            if($(this).hasClass('-selected'))
            {
                $(this).removeClass('-selected');
            }
        })

        $(this).addClass('-selected');

        $('.chosen-date').fadeIn();
        $('.chosen-date').html(chosen_date);
        $('.chosen-select').fadeIn();
        $('.date').val(chosen_date);

        return false;
    })

    var times = [];

    $('.time-block').click(function()
    {
        var id = $(this).data('id');
        var chosen_time = $(this).data('time');

        if ($('.-chosen').length < 3 || $(this).hasClass('-chosen'))
        {
            if($(this).hasClass('-chosen'))
            {
                $(this).removeClass('-chosen');

                times = $.grep(times, function(value)
                {
                    return value != id;
                });
            }
            else
            {
                times.push(id);

                $(this).addClass('-chosen');
            }
        }

        times.sort();

        var string = '';
        var time = '';

        $.each( times, function( key, value )
        {
            $('.time-block').each(function(i, obj)
            {
                if(value == $(this).data('id'))
                {
                    time = $(this).data('time');
                }
            });

            string+= ", " + time;
        });

        $('.at-time').fadeIn();

        string = string.replace(/^, /, '');

        $('.chosen-times').html(string);
        $('.times').val(times);
        $('.times_formatted').val(string);
    })

    //--------------------------
    // Functions

    // show modal to show error too.
    function shareModalError(){

        var target = $('.alert-form_error-share');

        if(target.length){

            $('#shareModal').modal('show');
        }
    }

    // show modal to show error too.
    function shareModalError(){

        var target = $('.alert-form_error-valuation');

        if(target.length){

            $('#bookViewingModal').modal('show');
        }
    }

    //--------------------------
    // Execute

    shareModalError();

})

$('#ajax-form-valuation').on('submit', function (e) {
    var errors = 0;
    var error_msg = '';

    var date = $('.booking-date').val();
    var times = $('.times').val();
    var name = $('.booking-name').val();
    var email = $('.booking-email').val();
    var phone = $('.booking-phone').val();
    var property_ref = $('.property_ref').val();
    var url = $('.url').val();
    var recaptcha_token = $(this).find('.recaptcha_token').val();

    var form = $('#ajax-form-valuation');

    $('.error-message').html('');

    if (e.isDefaultPrevented()) {
        // handle the invalid form...
    } else {
        e.preventDefault();
        error_msg = '';

        if(!date || date == '') {
            error_msg += '<p class="error-date mb-0">Please select a date</p>';
            errors++;
        }

        if(times == 0) {
            errors++;
            error_msg += '<p class="error-times mb-0">Please select three times</p>';
        } else {
            if(times.split(",").length < 3) {
                errors++;
                error_msg += '<p class="error-times mb-0">Please select three times</p>';
            }
        }

        if(errors == 0) {
            $('.errors').fadeOut();

            $.ajax(
                {
                    type: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { _token: $('meta[name="csrf-token"]').attr('content'), date: date, times: times, name: name, email: email, phone: phone, property_ref: property_ref, url: url, recaptcha_token: recaptcha_token },
                    url: '/request-viewing-form',
                    dataType: 'json',
                    success: function(data)
                    {
                        if(data.status == 'failed'){
                            $('.errors').fadeIn();
                            $('.error-message').html('<div class="alert alert-danger alert-form_error alert-form_error-valuation">'+data.message+'</div>');
                        }else{
                            $('.arrange-modal-title').text('');
                            $('.booking-confirm').text(Moment(date, "YYYY-DD-MM").format("dddd Do MMMM YYYY") + ' at ' + $('.times_formatted').val());
                            $('#ajax-form-valuation').addClass('d-none');
                            $('#ajax-form-success').removeClass('d-none');
                        }
                    }
                }
            )
        } else {
            $('.errors').fadeIn();
            $('.error-message').html(error_msg);
        }
    }
});
